function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Gro",
  transform: "translate(-334.998 -409.045)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_2",
  "data-name": "Line 2",
  y1: 2.63,
  x2: 2.594,
  transform: "translate(335.281 409.328)",
  fill: "none",
  stroke: "#1f1f1f",
  strokeLinecap: "round",
  strokeWidth: 0.4
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_3",
  "data-name": "Line 3",
  x1: 2.594,
  y1: 2.63,
  transform: "translate(337.876 409.328)",
  fill: "none",
  stroke: "#1f1f1f",
  strokeLinecap: "round",
  strokeWidth: 0.4
}));

function SvgUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 5.754,
    height: 3.196,
    viewBox: "0 0 5.754 3.196",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.5d1ae02d.svg";
export { ForwardRef as ReactComponent };